/*
 * @Description:
 * @Date: 2022-09-19 10:13:07
 */
// import store from './store';
import { route } from './src/router';

const name = 'terminal-pay';

export { name, route };
